export default __webpack_public_path__ + "static/media/organisation.2ddd71d7.svg";